enum UtmEnum {
  UtmCampaign = 'utm_campaign',
  UtmMedium = 'utm_medium',
  UtmSource = 'utm_source',
}

export default UtmEnum
